import React from "react"
import '../styles/photography.css'

import PointReyes from '../photos/edited/IMG_0036.jpg'
import SanFrancisco from '../photos/edited/IMG_0596.jpg'
import CatalinaFox from '../photos/edited/IMG_0846.jpg'
import Paris from '../photos/edited/IMG_8611.jpg'
import InisOirr from '../photos/edited/IMG_9030.jpg'


function Photo(props){
  return (
    <div className="gallery-spot">
      <a target="_blank" rel="noreferrer" href={props.filePath} >
        <img className="photo"
          src={props.filePath}
          alt={props.name}
            loading="lazy"
        />
      </a>
      <div className="location">
        <div className="location-text">{props.location}</div>
      </div>
    </div>
  )
}

export default function Photography() {
  return (
    <div className="photography">
      <div className="section-header">Photography</div>
        <div className="gallery">
            <Photo
                filePath={InisOirr}
                alt="Inis O&iacute;rr"
                location="Inis O&iacute;rr, Ireland"
            />
            <Photo
                filePath={SanFrancisco}
                alt="Golden Gate Bridge"
                location="San Francisco, California"
            />
            <Photo
                filePath={Paris}
                alt="Sacr&eacute;-Coeur"
                location="Sacr&eacute;-Coeur Paris, France"
            />
            <Photo
                filePath={CatalinaFox}
                alt="Catalina Island Fox"
                location="Catalina Island, California"
            />
            <Photo
                filePath={PointReyes}
                alt="Point Reyes"
                location="Point Reyes, California"
            />
        </div>
    </div>
  );
}
